import { render, staticRenderFns } from "./TagPopulation.vue?vue&type=template&id=0209a2fa&"
import script from "./TagPopulation.vue?vue&type=script&lang=js&"
export * from "./TagPopulation.vue?vue&type=script&lang=js&"
import style0 from "./TagPopulation.vue?vue&type=style&index=0&id=0209a2fa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports